import React, { useEffect, useState } from 'react';
import { Modal, Typography, Space, Button, List } from 'antd';
import {
  ThunderboltOutlined,
  UserOutlined,
  InboxOutlined,
  AppstoreOutlined,
  MenuOutlined,
} from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const TUTORIAL_SEEN_KEY = 'commandPaletteTutorialSeen';

export default function CommandPaletteTutorial() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Показываем подсказку только один раз при первом входе
    const hasSeenTutorial = localStorage.getItem(TUTORIAL_SEEN_KEY);
    if (!hasSeenTutorial) {
      // Задержка в 2 секунды для лучшего UX
      setTimeout(() => {
        setVisible(true);
      }, 2000);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(TUTORIAL_SEEN_KEY, 'true');
    setVisible(false);
  };

  const features = [
    {
      icon: <UserOutlined style={{ fontSize: 20, color: '#1890ff' }} />,
      title: 'Поиск клиентов',
      description: 'Находите клиентов по имени, видьте долги сразу в результатах',
    },
    {
      icon: <InboxOutlined style={{ fontSize: 20, color: '#52c41a' }} />,
      title: 'Поиск материалов',
      description: 'Проверяйте остатки материалов мгновенно',
    },
    {
      icon: <AppstoreOutlined style={{ fontSize: 20, color: '#722ed1' }} />,
      title: 'Поиск продукций',
      description: 'Находите продукции и их остатки за секунды',
    },
    {
      icon: <MenuOutlined style={{ fontSize: 20, color: '#fa8c16' }} />,
      title: 'Навигация по меню',
      description: 'Переходите к любому разделу одним кликом',
    },
  ];

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button 
          key="close" 
          type="primary" 
          onClick={handleClose}
          size="large"
          style={{
            borderRadius: 6,
            height: 40,
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          Понятно!
        </Button>,
      ]}
      width={600}
      centered
      className="command-palette-tutorial-modal"
    >
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div
          style={{
            width: 64,
            height: 64,
            margin: '0 auto 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 12,
            background: '#3b82f6',
          }}
        >
          <ThunderboltOutlined style={{ fontSize: 32, color: 'white' }} />
        </div>
        <Title level={3} style={{ marginBottom: 8, fontSize: 20, fontWeight: 600, color: '#111827' }}>
          Command Palette
        </Title>
        <Text style={{ fontSize: 14, color: '#6b7280' }}>
          Быстрый поиск и навигация
        </Text>
      </div>

      <div
        style={{
          padding: '16px 20px',
          background: '#eff6ff',
          borderRadius: 8,
          marginBottom: 20,
          border: '1px solid #3b82f6',
        }}
      >
        <Space direction="vertical" size={6} style={{ width: '100%', textAlign: 'center' }}>
          <Text strong style={{ fontSize: 13, color: '#1e40af' }}>
            Открыть:
          </Text>
          <div>
            <span
              style={{
                display: 'inline-block',
                padding: '6px 12px',
                background: 'white',
                border: '1px solid #3b82f6',
                borderRadius: 4,
                fontSize: 14,
                fontWeight: 600,
                color: '#1e40af',
                marginRight: 8,
              }}
            >
              Ctrl + K
            </span>
            <Text style={{ margin: '0 6px', color: '#6b7280', fontSize: 13 }}>или</Text>
            <span
              style={{
                display: 'inline-block',
                padding: '6px 12px',
                background: 'white',
                border: '1px solid #3b82f6',
                borderRadius: 4,
                fontSize: 14,
                fontWeight: 600,
                color: '#1e40af',
                marginLeft: 8,
              }}
            >
              Cmd + K
            </span>
          </div>
        </Space>
      </div>

      <div style={{ marginBottom: 20 }}>
        <Text strong style={{ fontSize: 14, color: '#374151', marginBottom: 12, display: 'block' }}>
          Что можно найти:
        </Text>
        <List
          dataSource={features}
          renderItem={(item) => (
            <List.Item style={{ border: 'none', padding: '8px 0' }}>
              <List.Item.Meta
                avatar={
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 8,
                      background: '#f3f4f6',
                      border: '1px solid #e5e7eb',
                    }}
                  >
                    {item.icon}
                  </div>
                }
                title={<Text strong style={{ fontSize: 13, color: '#111827' }}>{item.title}</Text>}
                description={<Text style={{ fontSize: 12, color: '#6b7280' }}>{item.description}</Text>}
              />
            </List.Item>
          )}
        />
      </div>

      <div
        style={{
          padding: 12,
          background: '#fef3c7',
          border: '1px solid #f59e0b',
          borderRadius: 6,
        }}
      >
        <Text style={{ fontSize: 12, color: '#78350f' }}>
          <strong>Совет:</strong> Используйте стрелки ↑↓ для навигации и Enter для выбора.
        </Text>
      </div>

      <style>{`
        .command-palette-tutorial-modal .ant-modal-content {
          border-radius: 8px;
          padding: 24px;
        }
        .command-palette-tutorial-modal .ant-modal-footer {
          border-top: 1px solid #e5e7eb;
          padding-top: 16px;
          text-align: center;
        }
      `}</style>
    </Modal>
  );
}

